import React from "react";
import Field from "../Common/Field";

export default class Text extends Field {
  renderInput() {
    const {
      formikField,
      isRequired,
      config: { name, placeholder, readOnly, disabled, validation = {} },
    } = this.props;

    let type = "text";
    if (
      validation.rules &&
      validation.rules.find((rule) => rule.type === "email")
    )
      type = "email";

    return (
      <input
        id={name}
        className="field__input field__input--text"
        type={type}
        placeholder={placeholder}
        readOnly={!!readOnly}
        disabled={!!disabled}
        aria-required={!!isRequired}
        {...formikField}
        onFocus={this.onFocus}
        onBlur={this.onBlur}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FormTemplates/Field/Text.js